import { KeyboardEvent } from "react";

import { AutocompleteOptionType } from "./dropdown-autocomplete";

interface Params {
  options: AutocompleteOptionType[];
  cursor: number;
  setCursor: (value: number | ((prev: number) => number)) => void;
  onSelectOption?: (option: AutocompleteOptionType) => void;
  setVisible?: (value: boolean) => void;
}

export const useKeyboardNavigation = ({
  options,
  cursor,
  setCursor,
  onSelectOption,
  setVisible,
}: Params) => {
  return (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && options.length > 0) {
      e.preventDefault();
      if (onSelectOption) onSelectOption(options[cursor]);
      if (setVisible) setVisible(false);
    }

    if (e.key === "ArrowUp") {
      if (cursor > 0) {
        setCursor((s) => s - 1);
      }
    }

    if (e.key === "ArrowDown") {
      if (cursor < options.length - 1) {
        setCursor((s) => s + 1);
      }
    }

    if (e.key === "Escape" && setVisible) {
      setVisible(false);
    }
  };
};
